import { useState, useEffect } from "react";
import { TextAreaFieldProps } from "./TextAreaField";

export const useTextAreaField = (props: TextAreaFieldProps) => {
  const [localValue, setLocalValue] = useState<string | undefined>(props.value);

  useEffect(() => {
    setLocalValue(props.value);
  }, [props.value]);

  return { localValue, setLocalValue };
};
